<template>
  <div>
    <b-row>
      <b-col cols="3">
        <label for="">Sucursal</label>
        <b-form-select
          v-model="compPagoServicio.selectedStore"
          :options="stores"
        >
          <template #first>
            <b-form-select-option :value="null" disabled
              >Seleccione la sucursal</b-form-select-option
            >
          </template>
        </b-form-select>
      </b-col>
      <b-col cols="3">
        <label>F.compra</label>
        <b-form-input
          type="date"
          v-model="compPagoServicio.fecha"
          size="md"
          placeholder="Fecha"
        ></b-form-input>
      </b-col>
      <b-col cols="2">
        <label>Caja</label>
        <b-form-input
          v-model="compPagoServicio.caja"
          size="md"
          placeholder="N° caja"
        ></b-form-input>
      </b-col>
      <b-col cols="2">
        <label>Secuencia</label>

        <b-form-input
          v-model="compPagoServicio.secuencia"
          size="md"
          placeholder="Secuencia"
        ></b-form-input>
      </b-col>
      <b-col cols="2" class="display-flex">
        <b-button
          class="rounded-button border-none align-bottom"
          @click="searchInfoCP"
        >
          <font-awesome-icon icon="search" />
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-table
          :busy="isBusyCP"
          class="tab-b"
          ref="selectableTable"
          selectable
          :select-mode="selectMode"
          :items="listSkuCP"
          :fields="fields"
          @row-selected="onRowSelected"
          responsive="sm"
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapState } from "vuex";
import axios from "axios";
import {getStores} from '../../assets/js/common'
export default {
  name: "ModalSkuComp",
  data() {
    return {
      fields: [
        { key: "selected", label: "  " },
        { key: "sku", label: "SKU" },
        { key: "description", label: "Descripción" },
        { key: "quantity", label: "Cantidad" },
      ],
      selectMode: "single",
      selected: [],
      compPagoServicio: {
        selectedStore: null,
        fecha: "",
        secuencia: "",
        caja: "",
      },
      stores: [],
      listSkuCP: [],
      selectedSkuCP: [{ sku: "" }],
      isBusyCP: false,
    };
  },
  created() {
    this.getStoresCombo();
  },
  computed: {
    ...mapState({
      store: (state) => state.store
    }),
    ...mapState("module", ["token"]),
  },
  methods: {
    async getStoresCombo() {
      try {
        let data = await getStores();
        this.stores = data;
      } catch (error) {
        console.error(error);
      }
    },
    async searchInfoCP(){
      this.isBusyCP = true;
      try{
      
       let response = await axios.get(
          process.env.VUE_APP_PAYMENT_REF +
            "/voucher-ref?Date=" +
            this.compPagoServicio.fecha +
            "&Pos=" +
            this.compPagoServicio.caja +
            "&Sequence=" +
            this.compPagoServicio.secuencia +
            "&Store=" +
            this.compPagoServicio.selectedStore,
            {
              headers: {
                  "Content-type": "application/json",
                  "Authorization": "Bearer "+ this.token
                }
            }
        );
      
        const services = response.data.details.map((row) => {
          return {
            sku: row.sku,
            description: row.description,
            quantity: row.quantity,
            folio:response.data.serial
          };
        });
        this.listSkuCP = services;
      }
      catch(error){
        console.log(error);
      }
      finally{
        this.isBusyCP = false;
      }
      
        
    },
    async searchInfoCPV2() {
      try {
        this.isBusyCP = true;

        let response = await axios.get(
          process.env.VUE_APP_PAYMENT_REF +
            "/vouchers-refactoring?date=" +
            this.compPagoServicio.fecha +
            "&pos=" +
            this.compPagoServicio.caja +
            "&sequence=" +
            this.compPagoServicio.secuencia +
            "&store=" +
            this.compPagoServicio.selectedStore
        );
        const services = response.data[0].details.map((row) => {
          return {
            sku: row.sku,
            description: row.description,
            quantity: row.quantity,
            services: row.services.map((ro) => {
              return {
                sku: ro.sku,
                description: ro.description,
              };
            }),
          };
        });

        this.listSkuCP = services;
      } catch (error) {
        console.log(error);
      } finally {
        this.isBusyCP = false;
      }
    },
    onRowSelected(items) {
     let data=this.compPagoServicio
      //this.selectedSkuCP = items;
      //console.log(this.selectedSkuCP);
      this.$emit("rowSelectedSku", items,data);
      this.$root.$emit("bv::hide::modal", "modal-cp");
    },
  },
};
</script>
<style scoped>
.bg-red {
  background: #ff4c4c;
}
.color-white {
  color: white;
}
.width-10 {
  width: 21px;
  height: 23px;
  text-align: center;
}
.border-gray {
  border: 1px solid gray;
}
.bg-white {
  background: white;
  border-color: gray;
}

::v-deep .b-table thead {
  background-color: transparent !important;
  color: black !important;
  font-weight: 500 !important;
  border: none !important;
}
::v-deep .b-table thead th {
  font-weight: 700 !important;
  border: none !important;
  font-size: 11pt;
}
.btn-secondary:not(:disabled):not(.disabled):active {
  border-color: transparent !important;
}
.btn-secondary:focus,
.btn-secondary.focus {
  border-color: transparent !important;
}
::v-deep .modal-title {
  color: #ff7a00 !important;
}
.btn-secondary {
  border: none !important;
}
.align-bottom {
  align-self: flex-end;
}
.display-flex {
  display: flex;
}
</style>
